import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftRight, Check } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useApp } from "../context/AppContext";
import { listMyAccounts, roleHome, apiErrorMessage } from "../lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { ROLE_ICONS } from "./roles";

// Shown only when the login group has more than one profile (same email, e.g. parent + trainer).
export function ProfileSwitcher({ className = "", iconOnly = false, testid = "profile-switcher" }) {
  const { user, switchAccount } = useAuth();
  const { t, lang } = useApp();
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const acct = user?.acct;
  useEffect(() => { if (acct?.length > 1) listMyAccounts().then((d) => setAccounts(d.accounts)).catch(() => setAccounts([])); else setAccounts([]); }, [acct, user?.id]);
  if (!acct || acct.length < 2 || !accounts.length) return null;
  const go = async (id) => { if (id === user.id) return; try { const u = await switchAccount(id); navigate(roleHome(u.role)); } catch (e) { toast.error(apiErrorMessage(e)); } };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={testid} title={t("switchProfile")} aria-label={t("switchProfile")} className={className || "inline-flex items-center gap-1.5 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-sm px-3 py-1.5 transition-colors"}>
          <ArrowLeftRight size={15} />{!iconOnly && <span className="hidden sm:inline">{t("switchProfile")}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64" dir={lang === "ar" ? "rtl" : "ltr"}>
        <DropdownMenuLabel className="text-xs text-slate-500">{t("switchProfile")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {accounts.map((a, i) => { const Icon = ROLE_ICONS[a.role] || ArrowLeftRight; const current = a.id === user.id; return (
          <DropdownMenuItem key={a.id} data-testid={`profile-option-${i}`} onClick={() => go(a.id)} className="gap-2.5 cursor-pointer">
            <Icon size={16} className="text-slate-500 shrink-0" />
            <span className="min-w-0 flex-1"><span className="block text-sm font-semibold">{lang === "ar" ? a.role_label_ar : a.role_label}</span><span className="block text-xs text-slate-500 truncate">{(lang === "ar" && a.org_name_ar) || a.org_name}</span></span>
            {current && <Check size={14} className="text-[#0038EB]" />}
          </DropdownMenuItem>); })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
